import {Component, Inject, OnInit, PLATFORM_ID, ChangeDetectionStrategy} from '@angular/core';
import {SubscriptionService} from '../shared/services/subscription.service';
import {DefaultUrlSerializer} from '@angular/router';
import {isPlatformBrowser, Location} from '@angular/common';

@Component({
    selector: 'mbnm-unsubscribe',
    templateUrl: './unsubscribe.component.html',
    styleUrls: ['./unsubscribe.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnsubscribeComponent implements OnInit {

  constructor(private subscriptionService: SubscriptionService,
              private location: Location,
              @Inject(PLATFORM_ID) private platformId: Object) {

  }

  public listName = '';
  public status = 'IN_PROGRESS';
  public error: any;
  public isBrowser = false;

  async ngOnInit() {
    this.isBrowser = isPlatformBrowser(this.platformId);
    const urlSerializer: DefaultUrlSerializer = new DefaultUrlSerializer();
    const url = urlSerializer.parse(this.location.path());
    this.listName = url.queryParams.list === 'abandoned-carts' ? 'abandoned cart emails' : 'newsletter';
    try {
      await this.subscriptionService.unsubscribe(url.queryParams.email, url.queryParams.list);
      this.status = 'DONE';
    } catch (errorResponse: any) {
      this.status = 'ERROR';
      this.error = errorResponse.error;
    }
  }
}
